import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of, shareReplay, tap } from 'rxjs';
import { TokenStorageService } from '../core/auth/token-storage.service';
import { environment } from '../../environments/environment';

interface KiHinweis {
  bestaetigtAm?: string | null;
}

interface Stand {
  sitzung: string | null;
  bestaetigt: Observable<boolean>;
}

/**
 * Ob der Erst-Nutzungs-Hinweis bestätigt ist, gelesen einmal je Sitzung. Die Bestätigung gilt je
 * Benutzer des Mandanten; ein OTP-Login wechselt den Benutzer ohne Neuladen der Seite und damit
 * nur am Token erkennbar, ein Azure-Logout lädt die Seite neu.
 */
@Injectable({ providedIn: 'root' })
export class KiHinweisService {
  private readonly http = inject(HttpClient);
  private readonly tokens = inject(TokenStorageService);
  private readonly url = `${environment.apiBaseUrl}/api/v1/users/me/ki-hinweis`;
  private stand?: Stand;

  /** Ein Lesefehler zeigt lieber den Hinweis einmal zu viel und wird beim nächsten Aufruf neu versucht. */
  bestaetigt(): Observable<boolean> {
    const sitzung = this.tokens.accessToken();
    if (!this.stand || this.stand.sitzung !== sitzung) {
      const stand: Stand = {
        sitzung,
        bestaetigt: this.http.get<KiHinweis>(this.url).pipe(
          map((hinweis) => !!hinweis.bestaetigtAm),
          catchError(() => {
            if (this.stand === stand) this.stand = undefined;
            return of(false);
          }),
          shareReplay(1),
        ),
      };
      this.stand = stand;
    }
    return this.stand.bestaetigt;
  }

  bestaetigen(): Observable<void> {
    const sitzung = this.tokens.accessToken();
    return this.http.put<void>(this.url, null).pipe(tap(() => (this.stand = { sitzung, bestaetigt: of(true) })));
  }
}
